(() => {
  function init(header) {
    if (header.dataset.adStickyBound) return;
    header.dataset.adStickyBound = 'true';
    const slot = header.closest('[data-ad-header-slot]');
    const root = document.documentElement;
    root.classList.add('ad-sticky-enabled');
    let frame = 0, resizeFlow = false;
    function setProperty(element, name, value) {
      if (element.style.getPropertyValue(name) !== value) element.style.setProperty(name, value);
    }
    function update() {
      frame = 0;
      if (!header.isConnected) return;
      if (resizeFlow) {
        header.classList.remove('is-sticky');
        slot.style.height = '';
        resizeFlow = false;
      }
      const slotTop = slot.getBoundingClientRect().top + window.scrollY;
      const sticky = window.scrollY > slotTop + 1;
      if (sticky && !header.classList.contains('is-sticky')) {
        // Preserve its original place in the page before compacting the header.
        slot.style.height = `${header.getBoundingClientRect().height}px`;
        header.classList.add('is-sticky');
      } else if (!sticky && header.classList.contains('is-sticky')) {
        header.classList.remove('is-sticky');
        slot.style.height = '';
      }
      const height = sticky ? header.getBoundingClientRect().height : 0;
      setProperty(root, '--ad-sticky-height', `${height}px`);
      const scrollOffset = height || (window.matchMedia('(max-width: 749px)').matches ? 102 : 110);
      setProperty(root, '--ad-sticky-scroll-offset', `${scrollOffset}px`);
      root.classList.toggle('ad-sticky-active', sticky);
      const viewport = window.visualViewport;
      const viewportBottom = (viewport?.height || window.innerHeight) + (viewport?.offsetTop || 0);
      let bottomBuyBar = 0;
      document.querySelectorAll('.productView-stickyCart.style-1.show-sticky, .ad-buybar:not([hidden])').forEach(bar => {
        const style = getComputedStyle(bar);
        const bounds = bar.getBoundingClientRect();
        if (style.visibility !== 'hidden' && Number(style.opacity) > 0 && bounds.top < viewportBottom) {
          bottomBuyBar = Math.max(bottomBuyBar, viewportBottom - bounds.top);
        }
      });
      const form = header.querySelector('.ad-search');
      const nav = header.querySelector('.ad-nav');
      const purchaseButtons = [...document.querySelectorAll('#tcustomizer-add, #product-add-to-cart, .ad-product-button, #show-sticky-product')];
      [[form, form.getBoundingClientRect().bottom + 8], [nav, nav.getBoundingClientRect().bottom]].forEach(([element, top]) => {
        let room = Math.max(80, viewportBottom - top - bottomBuyBar - 12);
        const panelBounds = element.getBoundingClientRect();
        purchaseButtons.forEach(button => {
          const bounds = button.getBoundingClientRect();
          const style = getComputedStyle(button);
          const available = bounds.top - top - 20;
          if (bounds.width && bounds.height && style.visibility !== 'hidden' && Number(style.opacity) > 0 && available >= 120 && bounds.top < viewportBottom && bounds.left < panelBounds.right && bounds.right > panelBounds.left) room = Math.min(room, available);
        });
        setProperty(element, '--ad-panel-room', `${room}px`);
      });
    }
    function schedule() {
      if (!frame) frame = requestAnimationFrame(update);
    }
    function onResize() { resizeFlow = true; schedule(); }
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', onResize, { passive: true });
    window.addEventListener('pageshow', schedule);
    header.addEventListener('focusin', schedule);
    header.addEventListener('toggle', schedule, true);
    window.visualViewport?.addEventListener('resize', schedule, { passive: true });
    window.visualViewport?.addEventListener('scroll', schedule, { passive: true });
    const observer = new ResizeObserver(schedule);
    observer.observe(header);
    document.querySelectorAll('.productView-stickyCart, .ad-buybar').forEach(bar => observer.observe(bar));
    update();
    header.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => {
      observer.disconnect();
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', onResize);
      window.removeEventListener('pageshow', schedule);
      header.removeEventListener('focusin', schedule);
      header.removeEventListener('toggle', schedule, true);
      window.visualViewport?.removeEventListener('resize', schedule);
      window.visualViewport?.removeEventListener('scroll', schedule);
      if (frame) cancelAnimationFrame(frame);
      root.classList.remove('ad-sticky-active', 'ad-sticky-enabled');
      root.style.removeProperty('--ad-sticky-height');
      root.style.removeProperty('--ad-sticky-scroll-offset');
    }, { once: true });
  }
  document.querySelectorAll('[data-ad-sticky-header]').forEach(init);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-ad-sticky-header]').forEach(init);
  });
})();
